import { render, staticRenderFns } from "./StudentTransfer.vue?vue&type=template&id=13b31396&"
import script from "./StudentTransfer.vue?vue&type=script&lang=js&"
export * from "./StudentTransfer.vue?vue&type=script&lang=js&"
import style0 from "./StudentTransfer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports